import React from 'react';

const CardView = (props) => <div className='flex-wrap w-screen bg-white rounded shadow h-254'>{props.children}</div>;

export default CardView;
